import { UploadResponse } from "@jnext/ts-axios-corecontentio";
import { ColProps } from "antd";
import { DEFAULT_FORMAT_DATE_FORM, DEFAULT_FORMAT_DATETIME_FORM } from "../lib";
import { CompositorContextModel } from "./components/CompositorProvider";

export const DEFAULT_ROW_GUTTER = 16
export const DEFAULT_CONTENTIO_MIDDLEPATH = 'uploads'
export const DEFAULT_CONTENTIO_MODULENAME = 'jnext'

export const DEFAULT_HALF_COL_PROPS: ColProps = {
    xs: 24,
    sm: 24,
    md: 12
}
export const DEFAULT_FULL_COL_PROPS: ColProps = {
    span: 24
}
export enum TRANSLATION_CODES {
    NOT_FOUND_CONTENT = 'FORM_field_no_found_content',
    PHONE_PREFIX_CODE = 'FORM_fields_phone_prefix_code',
    REQUIRED = 'FORM_field_required',
    CONFIRM = 'FORM_field_confirm',
    NO_MATCH = 'FORM_field_no_match',
    INVALID_DATE = 'FORM_field_invalid_date',
    INVALID_PHONE = 'FORM_field_invalid_phone',
    WRONG_FORMAT = 'FORM_field_wrong_format',
    READ_ALL = 'FORM_field_read_All',
    GOT_IT = 'FORM_labels_got_it',
    CROP_CANCEL = 'FORM_field_crop_cancel',
    CROP_SAVE = 'FORM_field_crop_save',
    START_DATE = 'FORM_field_start_date',
    END_DATE = 'FORM_field_end_date',
    MAX_SIZE = 'FORM_field_max_size',
    MAX_SIZE_EXCEEDED = 'FORM_field_max_size_exceeded',
    UPLOAD_DESCRIPTION = 'FORM_field_upload_description',
    ADD = 'FORM_field_add_cta',
    REMOVE = 'FORM_field_remove_cta'
}
export const JSELECT_CUSTOM_VALUE = 'enter-custom-text'
export const DEFAULT_CONTEXT_VALUES: CompositorContextModel = {
    avatarShape: 'circle',
    formatDate: DEFAULT_FORMAT_DATE_FORM,
    formatDateTime: DEFAULT_FORMAT_DATETIME_FORM,
    translate: (code: string) => { console.warn('[FORM_COMPOSITOR]: Translate function not implemented.'); return code; },
    templateCode: 'T1',
    showFieldsLabel: false,
    uploadFiles: function (): Promise<UploadResponse[]> {
        throw new Error('[FORM_COMPOSITOR]: uploadFile function not implemented.');
    },
    getURLFromFileRef: function (): Promise<string> {
        throw new Error('[FORM_COMPOSITOR]: getURLFromFileRef function not implemented.');
    },
    confirmsColProps: DEFAULT_HALF_COL_PROPS,
}